<script>
  import { onMount } from "svelte";
  import Conexoes from "../Classes/Conexoes";
  import Loading from "../componentes_basicos/Loading.svelte";

  let conexoes = new Conexoes(Constantes.url_base_nutri);
  let carregando = true;
  let dadosRelatorio = [];
  let dadosMacro = [];
  let mesesColunas = [];
  
  // 1. Nova ordem das categorias (conforme você pediu)
  const categorias = [
    // Transporte
    "Carro", "Combustivel", "Uber", "Estacionamentos",
    // Alimentação
    "Padaria", "Feira", "Lanche_lele_escola", "Lanche_lele_campestre", "Lanche_lele_outros",
    // Lazer e Outros
    "Restaurante", "Casa", "Gas", "Piscina", "Ração", "Medicamentos", "Suplementos", "Outros"
  ];

  // 2. Mapeamento para a tabela de Resumo (Macro-categorias)
  const grupos = {
    "Transporte": ["Carro", "Combustivel", "Uber", "Estacionamentos"],
    "Alimentação": ["Padaria", "Feira", "Lanche_lele_escola", "Lanche_lele_campestre", "Lanche_lele_outros"],
    "Lazer e Outros": ["Restaurante", "Casa", "Gas", "Piscina", "Ração", "Medicamentos", "Suplementos", "Outros"]
  };

  function gerarMeses() {
    let cols = [];
    let hoje = new Date();
    for (let i = 11; i >= 0; i--) {
      let d = new Date(hoje.getFullYear(), hoje.getMonth() - i, 1);
      let ano = d.getFullYear();
      let mes = String(d.getMonth() + 1).padStart(2, "0");
      cols.push(`${ano}-${mes}`);
    }
    return cols;
  }

  function formatarMes(anoMes) {
    const [ano, mes] = anoMes.split("-");
    const mesesNomes = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
    return `${mesesNomes[parseInt(mes) - 1]}/${ano.slice(2)}`;
  }

  const formatCurrency = (val) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val);

  async function carregarDados() {
    carregando = true;
    mesesColunas = gerarMeses();
    
    let res = await conexoes.conecta("relatorio_meses.php", {});
    
    if (res && res.data) {
      let mapa = {};
      let mapaMacro = { "Transporte": {}, "Alimentação": {}, "Lazer e Outros": {} };
      
      // Inicializa os mapas zerados
      categorias.forEach(cat => {
        mapa[cat] = {};
        mesesColunas.forEach(m => mapa[cat][m] = 0);
      });
      Object.keys(mapaMacro).forEach(g => {
        mesesColunas.forEach(m => mapaMacro[g][m] = 0);
      });

      // Preenche com os dados do banco
      res.data.forEach(item => {
        // Se existir categoria antiga não mapeada, cria ela
        if (!mapa[item.categoria]) {
          mapa[item.categoria] = {};
          mesesColunas.forEach(m => mapa[item.categoria][m] = 0);
        }
        
        if (mapa[item.categoria][item.mes_ano] !== undefined) {
          let val = parseFloat(item.total);
          mapa[item.categoria][item.mes_ano] = val;

          // Descobre a qual grupo a categoria pertence e soma lá também
          let grupoEncontrado = "Lazer e Outros"; // Cai aqui por padrão se não achar
          for (const [nomeGrupo, cats] of Object.entries(grupos)) {
            if (cats.includes(item.categoria)) {
              grupoEncontrado = nomeGrupo;
              break;
            }
          }
          mapaMacro[grupoEncontrado][item.mes_ano] += val;
        }
      });

      let mesAtual = mesesColunas[mesesColunas.length - 1]; 
      let colunas6m = mesesColunas.slice(-7, -1); 

      // Função auxiliar para evitar código repetido no cálculo das médias
      const calcularLinha = (nomeCategoria, valores) => {
        let total12m = 0, total6m = 0, cont12m = 0, cont6m = 0;
        
        mesesColunas.forEach(m => {
          let val = valores[m] || 0;
          if (m !== mesAtual && val > 0) {
            total12m += val;
            cont12m++; 
            if (colunas6m.includes(m)) {
              total6m += val;
              cont6m++; 
            }
          }
        });

        return {
          categoria: nomeCategoria,
          valores: valores,
          media6m: cont6m > 0 ? total6m / cont6m : 0,
          media12m: cont12m > 0 ? total12m / cont12m : 0
        };
      };

      // Monta a Tabela 1: Força a ordem correta usando o array `categorias`
      let categoriasExtras = Object.keys(mapa).filter(k => !categorias.includes(k));
      let todasCategoriasOrdenadas = [...categorias, ...categoriasExtras];
      
      dadosRelatorio = todasCategoriasOrdenadas.map(cat => calcularLinha(cat, mapa[cat]));

      // Monta a Tabela 2: Resumo Macro
      dadosMacro = Object.keys(mapaMacro).map(grupo => calcularLinha(grupo, mapaMacro[grupo]));
    }
    carregando = false;
  }

  onMount(() => {
    carregarDados();
  });
</script>

<style>
  .container {
    max-width: 1200px;
    margin: 20px auto;
    background: #f9f9f9;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .table-wrapper {
    width: 100%;
    overflow-x: auto;
    margin-bottom: 40px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    background: #fff;
    min-width: 900px;
  }

  th, td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: right;
    white-space: nowrap;
  }

  th:first-child, td:first-child {
    text-align: left;
    font-weight: bold;
    color: #444;
  }

  th {
    background-color: #3659fc;
    color: white;
    text-align: center;
  }

  /* Estilo diferente pro cabeçalho da tabela de resumo */
  .th-resumo {
    background-color: #2b45c2; 
  }

  tr:hover {
    background-color: #f1f4ff;
  }

  .media-col {
    background-color: #eef1ff;
    font-weight: bold;
    color: #3659fc;
  }
  
  .valor-zerado {
    color: #ccc;
  }
  
  h2, h3 {
    color: #3659fc;
    margin-top: 0;
  }
</style>

<div class="container">
  <h2>Análise Mensal de Gastos</h2>
  
  {#if carregando}
    <div style="display:flex; justify-content:center; padding: 30px;">
      <Loading {carregando} />
    </div>
  {:else}
    
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Categoria</th>
            {#each mesesColunas as mes}
              <th>{formatarMes(mes)}</th>
            {/each}
            <th class="media-col">Média 6M</th>
            <th class="media-col">Média 12M</th>
          </tr>
        </thead>
        <tbody>
          {#each dadosRelatorio as linha}
            <tr>
              <td>{linha.categoria}</td>
              {#each mesesColunas as mes}
                <td class={linha.valores[mes] === 0 ? 'valor-zerado' : ''}>
                  {formatCurrency(linha.valores[mes])}
                </td>
              {/each}
              <td class="media-col">{formatCurrency(linha.media6m)}</td>
              <td class="media-col">{formatCurrency(linha.media12m)}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>

    <h3>Resumo por Grupo</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th class="th-resumo">Grupo</th>
            {#each mesesColunas as mes}
              <th class="th-resumo">{formatarMes(mes)}</th>
            {/each}
            <th class="media-col" style="background-color: #e3e8fc;">Média 6M</th>
            <th class="media-col" style="background-color: #e3e8fc;">Média 12M</th>
          </tr>
        </thead>
        <tbody>
          {#each dadosMacro as linha}
            <tr style="background-color: #fbfbfc;">
              <td style="color: #2b45c2;">{linha.categoria}</td>
              {#each mesesColunas as mes}
                <td class={linha.valores[mes] === 0 ? 'valor-zerado' : ''}>
                  {formatCurrency(linha.valores[mes])}
                </td>
              {/each}
              <td class="media-col">{formatCurrency(linha.media6m)}</td>
              <td class="media-col">{formatCurrency(linha.media12m)}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>

  {/if}
</div>